import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { receivingAccountDetailsItLabel } from 'projects/money-movement-ui/src/app/shared/utilities/Constants';
import { Subject, takeUntil } from 'rxjs';
import { selectToAccountInfo } from '../../../../../../create-request/reducers';
import { ToAccountInfo } from '../../../../../../create-request/models/internal-transfer/ToAccountInfo';

@Component({
  standalone: false,
  selector: 'mm-receiving-account-details-it-condensed',
  templateUrl: './receiving-account-details-it-condensed.component.html',
  styleUrl: './receiving-account-details-it-condensed.component.scss'
})
export class ReceivingAccountDetailsItCondensedComponent implements OnInit {

  readonly subtitle: string = 'Receiving account details';

  readonly labels = receivingAccountDetailsItLabel;

  destroy$: Subject<boolean> = new Subject<boolean>();
  toAccountInfo: ToAccountInfo;
  showToAccountAvailableCash: boolean;
  isToAccountSameFirm: boolean;


  constructor(private store: Store){ }

  ngOnInit(): void {

    this.store.select(selectToAccountInfo).pipe(takeUntil(this.destroy$)).subscribe((toAccountInfo) => {
      this.toAccountInfo = toAccountInfo;
      this.showToAccountAvailableCash = toAccountInfo.availableCashMmf !== '' && toAccountInfo.availableCashMmf !== null;
      if (toAccountInfo?.accountNumber) {
        this.isToAccountSameFirm = toAccountInfo.accountRegistration.length > 0;
      }
    });
    
  }

}
